export default __webpack_public_path__ + "locales/lv/Article.json?hash=e471c7b08a7f49814827e94b6034e0ae";